import { createAction, props } from '@ngrx/store';

import { FairsConfiguration } from '../../../interfaces/environment.interfaces';
import { Fair } from '../../../interfaces/fair.interfaces';

export const fairLoadForExhibitorPage = createAction('[Exhibitor Page] Load fair', props<{ fairId: string }>());

export const fairsPageOpened = createAction('[Fairs Page] Opened');

export const fairOpened = createAction('[Fair Page] Opened', props<{ fairId: string }>());
export const fairLoadSucceeded = createAction('[Fair API] Fair load succeeded', props<{ fair: Fair }>());
export const fairLoadFailed = createAction('[Fair API] Fair load failed', props<{ error: string }>());

export const appOpened = createAction('[App] Opened');
export const appOpenedSucceeded = createAction('[App] Opened succeeded', props<{ config: FairsConfiguration }>());
export const appOpenedFailed = createAction('[Fair API] Opened failed', props<{ error: string }>());
